import { render } from "./VideoClip.vue?vue&type=template&id=706dd52e"
import script from "./VideoClip.vue?vue&type=script&lang=js"
export * from "./VideoClip.vue?vue&type=script&lang=js"

import "./VideoClip.vue?vue&type=style&index=0&id=706dd52e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__